import React, { FC } from "react";

import {
  SupplierCollectData,
  SupplierHubGuide,
  SupplierHubWelcomeBanner,
} from "@components/main/procurement";
import { CardContactSupport } from "@components/common";
import { Box, Grid } from "@components/base";

const SuppliersHubPage: FC = () => {
  return (
    <Box>
      <Grid container spacing={3}>
        <SupplierHubWelcomeBanner />
        <Grid size={12}>
          <SupplierHubGuide />
        </Grid>
        <Grid size={12}>
          <SupplierCollectData />
        </Grid>
        {/* TODO: hidden for now <Grid size={12}>
          <SupplierHubReports procurementId={procurementId} />
        </Grid> */}
        <Grid size={12}>
          <CardContactSupport />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SuppliersHubPage;
